// Utilities shared between Documents module and Dashboard "Cierre de Fase 2".
// Keep in sync with backend document_templates.py doc_type keys.

export function computeUrgency(docType, industry) {
  const ind = industry || 'otro';
  const universalRequired = ['privacy_policy', 'arco_notice'];
  if (universalRequired.includes(docType)) return 'obligatorio';

  if (docType === 'cookies_notice') {
    const requiredIn = ['retail', 'ecommerce', 'salud', 'educacion', 'fintech', 'servicios', 'tecnologia'];
    return requiredIn.includes(ind) ? 'obligatorio' : 'recomendado';
  }
  if (docType === 'consent_clause') {
    const requiredIn = ['retail', 'ecommerce', 'educacion', 'fintech', 'salud'];
    return requiredIn.includes(ind) ? 'obligatorio' : 'recomendado';
  }
  if (docType === 'dpa') return 'recomendado';
  return 'opcional';
}

export const URGENCY_META = {
  obligatorio: { label: 'Obligatorio', color: '#DC2626', bg: '#FEF2F2', border: '#FCA5A5' },
  recomendado: { label: 'Recomendado', color: '#92400E', bg: '#FFFBEB', border: '#FDE68A' },
  opcional:    { label: 'Opcional',    color: '#6B7280', bg: '#F3F4F6', border: '#E5E7EB' },
};

export const PUBLISH_LOCATIONS = {
  privacy_policy: 'Pie de página del sitio web + enlace en formularios de registro',
  cookies_notice: 'Banner de cookies + pie de página del sitio',
  consent_clause: 'Formularios de registro, newsletter, encuestas',
  dpa:            'Firmar con cada proveedor que trate datos personales por su empresa',
  arco_notice:    'Sitio web público + pie de correos + portal ARCO+ (Fase 3)',
};

/**
 * Given the list of docs (from /documents) and the org industry, return the
 * completion summary used by Documents page and Dashboard Fase 2 strip.
 */
export function computeDocsCompletion(docs, industry, docTypeKeys) {
  const grouped = docTypeKeys.map((key) => ({
    key,
    urgency: computeUrgency(key, industry),
    implemented: docs.some((d) => d.doc_type === key && d.implementation),
    published: docs.some((d) => d.doc_type === key && d.status === 'publicado'),
  }));
  const required = grouped.filter((g) => g.urgency === 'obligatorio');
  const recommended = grouped.filter((g) => g.urgency === 'recomendado');
  const requiredMissing = required.filter((g) => !g.implemented);
  const recommendedMissing = recommended.filter((g) => !g.implemented);
  const totalNeeded = required.length + recommended.length;
  const totalDone = totalNeeded - requiredMissing.length - recommendedMissing.length;
  const pct = totalNeeded > 0 ? Math.round((totalDone / totalNeeded) * 100) : 100;
  return { grouped, required, recommended, requiredMissing, recommendedMissing, totalNeeded, totalDone, pct };
}
